module.exports = {"sign":{"success":"Your signature was successfully signed","failed":"Failed to get signature"}};